import React from 'react';
import PropTypes from 'prop-types';

import Auth from 'works/legacy/lib/auth';

export function SupplierOnly({ children }) {
  if (Auth.signedIn() && !Auth.supplierMember()) return null;

  return <>{children}</>;
}

SupplierOnly.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};
